import { SumPlanStatusEntryDTO } from "../../../../services/paymentModule";

export interface SumPlanRow {
  planCode: string;
  planDescription: string;
  status: string;
  active: boolean;
  hasSubscription: boolean;
  cancelAtPeriodEnd: boolean;
  currentPeriodEnd?: string;
  lastPayment: { cents: number; currency: string; date: string } | null;
  refundable: boolean;
}

export interface GuaranteeTargetPlan {
  planCode: string;
  planDescription: string;
  lastPayment: { cents: number; currency: string; date: string } | null;
}
const REFUNDABLE_STATUSES = ["ACTIVE", "SUCCEEDED"];

export const sumPlanRows = (entries: SumPlanStatusEntryDTO[]): SumPlanRow[] =>
  entries.map((entry) => {
    const status = entry.status ?? "ENDED";
    const hasSubscription = entry.has_subscription === true;
    const lastPayment = entry.last_payment
      ? {
          cents: Number(entry.last_payment.amount),
          currency: (entry.last_payment.currency || "").toUpperCase(),
          date: entry.last_payment.date,
        }
      : null;
    return {
      planCode: entry.plan,
      planDescription: entry.description ?? "",
      status,
      active: status === "ACTIVE",
      hasSubscription,
      cancelAtPeriodEnd: entry.cancel_at_period_end === true,
      currentPeriodEnd: entry.current_period_end,
      lastPayment,
      refundable:
        hasSubscription &&
        !!lastPayment &&
        REFUNDABLE_STATUSES.includes(status),
    };
  });

export const toTargetPlan = (row: SumPlanRow): GuaranteeTargetPlan => ({
  planCode: row.planCode,
  planDescription: row.planDescription,
  lastPayment: row.lastPayment,
});
